import React, { Component } from "react";
import {config} from "../config";

export class Redirect extends Component {
    constructor( props ){
        super();
        this.state = { ...props };
    }

    componentDidMount() {
        var linkForReplace = this.props.match.params.link.replace(/-/g,"/").replace(/~/g,"?");
        window.location.href = config.apiUrl + linkForReplace;
    }

    render(){
        return (<section>Redirecting...</section>);
    }
}

export default Redirect;